import RowingIcon from '@material-ui/icons/Rowing';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import React from 'react';
import { TextField, useTranslate } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import CommonApplianceFilter from '../../components/organisms/commonApplianceFilter';
const ProgramsListPageList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.programs-list-page.name'),
            url: '',
            icon: <RowingIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                {...props}
                pagination={<DynamoPagination resource="programs-list-page" />}
                filters={<CommonApplianceFilter brand series applianceType />}
                bulkActionButtons={
                    permissions &&
                    permissions['programs-list-page'] &&
                    permissions['programs-list-page'].delete
                        ? undefined
                        : false
                }
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="applianceType" />
                    <TextField source="type" />
                    <TextField source="brand" />
                    <TextField source="series" />
                    <TextField label="active" source="isActive" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};
export default ProgramsListPageList;
